import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext, useQueryString } from '@frx/frx-react-context';

export interface Event {
  eventAction?: string;
  type?: string;
  pathname?: string;
  hash?: string;
  search?: string;
  pagename?: string;
  user?: {
    userId?: string;
    userName?: string;
    userType?: string;
  };
}

export interface Page {
  pathname?: string;
  search?: string;
  hash?: string;
}

export const setEvent = ({ pathname, search, hash, pagename, user }: Event) => {
  if (window.stjude) {
    const { page, sysEnv } = window.stjude.digitalData;
    const newPathName = '/logout';

    const eventObj = {
      category: {},
      eventInfo: {
        eventAction:
          pathname === newPathName ? newPathName : `${pathname}${search}`,
        eventName: 'spa-change',
        timeStamp: new Date(),
      },
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.stjude.digitalData.event.push(eventObj);

    window.stjude.digitalData.sysEnv = {
      ...sysEnv,
      environment:
        sysEnv.environment === 'dev' ? 'staging' : sysEnv.environment,
    };

    const pathFromUrl = `${pathname}${search}`;

    window.stjude.digitalData.page = {
      ...page,
      path: hash ? `${pathFromUrl}${hash}` : pathFromUrl,
      title: pagename || page?.title,
    };

    window.stjude.digitalData.user = { ...user };
  } else {
    console.warn(
      'No stjude object found for adobe launch tracking, setEvent function is noop'
    );
  }
};

export const useAnalytics = () => {
  const location = useLocation();
  const {
    queryStrings: { pagename },
  } = useQueryString();
  const {
    data: {
      authData: { user, loggedIn },
    },
  } = useAppContext();

  useEffect(() => {
    setEvent({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      pagename: pagename as string,
      user: {
        userId: user?.cons_id || loggedIn ? String(user?.cons_id) : 'anonymous',
        userName: user?.user_name || 'anonymous',
        userType: loggedIn ? 'p2p-participant' : 'p2p',
      },
    });
  }, [location, loggedIn, user?.cons_id, user?.user_name, pagename]);
};
